import React from 'react';
import { FormattedMessage } from 'react-intl';

const RequestedServiceLabel = () => (
  <FormattedMessage defaultMessage='Requested' description='fulfillmentPlanner.requestedService' id='OkbQYH' />
);

export default RequestedServiceLabel;
